/**
 * @author yili
 * @fileoverview 上下文
 */

export const homePageContextKey = Symbol();
